<script lang="ts" setup>
const props = defineProps({
  cars: {
    type: Array,
  }
})
const {t} = useI18n({
  useScope: 'global'
})
</script>

<template>
  <div class="list">
    <div v-if="props.cars?.length">
      <slot>
        <PageCarsItemLayout
          v-for="car2 in props.cars"
          :key="car2.id"
          :car="car2"
        >
          <template #featured-image="{car}">
            <PageCarsFeaturedImage :featured-image="car.featuredImage" />
          </template>
          <template #info-column-1="{car}">
            <PageCarsInfoItem
              :title="t('car.prop.vinCode')"
              :value="car.vinCode"
            />
            <PageCarsInfoItem
              :title="t('car.prop.auctionLot')"
              :value="car.auctionLot"
            />
            <PageCarsInfoItem
              :title="t('car.prop.shipmentFrom')"
              :value="car.shipmentFrom"
            />
          </template>
          <template #info-column-2="{car}">
            <PageCarsInfoItem
              :title="t('car.prop.shipName')"
              :value="car.shipName"
            />

            <PageCarsInfoItem
              type="link"
              :title="t('car.prop.containerNumber')"
              :value="car.containerNumber"
              :link="car.containerTrackUrl"
            />
            <PageCarsInfoItem
              :title="t('car.prop.shipmentDestination')"
              :value="car.shipmentDestination"
            />
          </template>
          <!--          <template #info-column-3="{car}">-->
          <!--            3-->
          <!--          </template>-->
          <template #info-column-4="{car}">
            <PageCarsInfoItem
              :title="t('car.prop.auctionName')"
            >
              <img
                v-if="car.auctionName === 'copart'"
                src="~/assets/img/pages/cars/auction.png"
                alt=""
              >
              <span v-else>{{ car.auctionName }}</span>
            </PageCarsInfoItem>
          </template>
          <template #footer="{car}">
            <PageCarsGuestItemFooter :car="car" />
          </template>
        </PageCarsItemLayout>
      </slot>
    </div>
    <div v-else>
      {{ t('cars.labels.empty') }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.list {
  width: 100%;
}
</style>


